module.exports = __webpack_public_path__ + "static/home_cold_circles-eb1b8da918696476275803d6044c8825.png";